/// <reference path="../../../../../typings.d.ts" />

import { Component } from '@angular/core';
import { ContractModelService } from '../contracts.model.service';
import { DocumentsHttpService } from '../../../../services/documents/documents.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { ContractsHttpUtil } from '../contracts.util';
import { CreateSignatureDialogContractStateService } from '../signature/signature.modal.state.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.documentation.component.html',
  styleUrls: ['contracts.documentation.component.css'],
  providers: []
})

export class ContractsDocumentationComponent {

  model: any = {};
  errorMessage: string;
  loadingFile: boolean = false;
  fileName: '';
  settings: any = {};

  constructor(private createSignatureDialogService: CreateSignatureDialogContractStateService,
              private contractModelService: ContractModelService,
              private documentsHttpService: DocumentsHttpService,
              private router: Router) {
                this.settings = environment;
  }

  ngOnInit() {
    this.model = this.contractModelService.getData();
    if (!this.settings.site.show_documents_tab_contract) {
      this.router.navigate(['contracts/' + this.model.id + '/accruals']);
    }
  }

  openSignatureDialog($event, attach, model) {
      $event.preventDefault();
      this.createSignatureDialogService.triggerDialogStatus({display: true, attach: attach, model: model});
  }

  acceptSign(attach) {
      let ext = attach.name.split('.').pop();
      return ext === 'docx' || ext === 'pdf';
  }

  download($event, attach) {
    $event.preventDefault();
	if (this.loadingFile) {
	  return false;
    }

    this.loadingFile = true;

    let data = {
      securityToken: StorageUtil.getToken(),
    };

    let requestParams = ContractsHttpUtil.prepareParamsDownload(data);
    this.documentsHttpService.getDocument(requestParams, attach.id)
      .map(res => {
        if(res.headers.get('content-disposition')) {
          return res.blob();
        }
      })
      .subscribe(
        blobContent => {
          this.loadingFile = false;
          if(blobContent) {
            saveAs(blobContent, attach.name);
          } else {
          }
        },
        error => {
          this.loadingFile = false;
        },
        () => {
          this.loadingFile = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/documentation/contracts.documentation.component.ts